export default __webpack_public_path__ + "static/media/IMG-activityPH_cognitive.2c0e1c44.png";